import en from './en/en.json';
import es from './es/es.json';
import pt from './pt/pt.json';
import zh from './zh/zh.json';
import ja from './ja/ja.json';

export default {
  en,
  es,
  pt,
  zh,
  ja,
};
